<div
  class="min-h-full flex flex-col bg-gradient-to-br from-slate-50 via-white to-blue-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900"
>
  <!-- HEADER STICKY - Tablet optimized -->
  <header
    class="bg-white dark:bg-slate-800/95 backdrop-blur-sm border-b border-gray-200 dark:border-slate-700 sticky top-0 z-30 shadow-sm dark:shadow-slate-900/30 flex-shrink-0"
  >
    <div class="px-4 md:px-6 py-3 flex items-center justify-between gap-4">
      <!-- Left: Title -->
      <div class="flex items-center gap-3">
        <button
          (click)="cancel()"
          class="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-lg transition-colors"
          title="Retour"
        >
          <svg
            class="w-5 h-5 text-gray-600 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <div>
          <h1
            class="text-lg md:text-xl font-bold text-gray-900 dark:text-white"
          >
            Mes Produits
          </h1>
          <p class="text-xs text-gray-500 dark:text-gray-400 hidden md:block">
            {{ marchandProducts.length }} produits configurés
          </p>
        </div>
      </div>

      <!-- Right: Actions -->
      <div class="flex items-center gap-2">
        <!-- Carte du menu -->
        <button
          (click)="showMenuCard = true"
          class="flex items-center gap-2 px-3 py-2 border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 dark:hover:bg-amber-900/40 rounded-lg text-sm font-medium transition-colors text-amber-800 dark:text-amber-300"
        >
          📋 <span class="hidden sm:inline">Carte du menu</span>
        </button>

        <!-- Auto-save indicator -->
        @if (isSaving) {
          <span class="text-xs text-gray-400 flex items-center gap-1">
            <svg class="w-3 h-3 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              ></path>
            </svg>
            Sauvegarde...
          </span>
        }
        @if (hasUnsavedChanges && !isSaving) {
          <span class="text-xs text-orange-500">● Non sauvegardé</span>
        }
      </div>
    </div>

    <!-- KPI Bar - Compact -->
    <div
      class="px-4 md:px-6 py-2 bg-gray-50 dark:bg-slate-900/80 border-t border-gray-100 dark:border-slate-700 flex items-center gap-4 md:gap-6 overflow-x-auto"
    >
      <div class="flex items-center gap-2 text-sm whitespace-nowrap">
        <span class="text-gray-500 dark:text-gray-400">Produits</span>
        <span class="font-bold text-gray-900 dark:text-white">{{
          marchandProducts.length
        }}</span>
      </div>
      <div class="w-px h-4 bg-gray-300"></div>
      <div class="flex items-center gap-2 text-sm whitespace-nowrap">
        <span class="text-gray-500 dark:text-gray-400">Valeur</span>
        <span class="font-bold text-green-600 dark:text-green-400"
          >{{ getTotalValue() | number: "1.0-0" }}€</span
        >
      </div>
      <div class="w-px h-4 bg-gray-300"></div>
      <div class="flex items-center gap-2 text-sm whitespace-nowrap">
        <span class="text-gray-500 dark:text-gray-400">Stock</span>
        <span class="font-bold text-gray-900 dark:text-white">{{
          getTotalQuantity()
        }}</span>
      </div>
      <div class="w-px h-4 bg-gray-300"></div>
      <div class="flex items-center gap-2 text-sm whitespace-nowrap">
        <span class="text-gray-500 dark:text-gray-400">Catégories</span>
        <span class="font-bold text-gray-900 dark:text-white">{{
          getUniqueCategories()
        }}</span>
      </div>
    </div>
  </header>

  <!-- Menu Card Modal -->
  @if (showMenuCard) {
    <app-menu-card
      [products]="marchandProducts"
      [merchantType]="
        merchantProfile.type === 'itinerant' ? 'itinerant' : 'fixed'
      "
      [businessName]="merchantProfile.businessName"
      (closed)="showMenuCard = false"
    ></app-menu-card>
  }

  <!-- MAIN CONTENT -->
  <main class="flex flex-col lg:flex-row flex-1">
    <!-- LEFT: Products Grid -->
    <section class="flex-1 flex flex-col p-4 md:p-6 lg:pr-0">
      <app-products-editor
        class="flex-1"
        [products]="marchandProducts"
        (productsChange)="onProductsChange($event)"
        (productSelected)="onProductSelected($event)"
        (templateApplied)="onTemplateApplied($event)"
        [showCatalogSearch]="showSearchCatalog"
        (closeCatalog)="showSearchCatalog = false"
      ></app-products-editor>
    </section>

    <!-- DESKTOP: Slide-in Panel from Right (visible on lg+) -->
    @if (selectedProduct) {
      <div class="hidden lg:block fixed inset-0 z-50">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity"
          (click)="selectedProduct = null"
        ></div>
        <!-- Slide-in Panel -->
        <aside
          class="absolute right-0 top-0 bottom-0 w-[420px] bg-white dark:bg-slate-800 shadow-2xl overflow-y-auto animate-slide-in-right"
        >
          <div
            class="sticky top-0 bg-white dark:bg-slate-800 border-b border-gray-100 dark:border-slate-700 p-4 flex items-center justify-between z-10"
          >
            <h2 class="font-bold text-gray-900 dark:text-white">
              Détails du produit
            </h2>
            <button
              (click)="selectedProduct = null"
              class="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-lg transition-colors"
            >
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="p-4 space-y-4">
            <!-- Product Header -->
            <div
              class="flex items-center gap-4 pb-4 border-b border-gray-100 dark:border-slate-700"
            >
              <div class="text-5xl">{{ selectedProduct.productIcon }}</div>
              <div class="flex-1">
                <h3 class="font-bold text-lg text-gray-900 dark:text-white">
                  {{ selectedProduct.name }}
                </h3>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  {{ selectedProduct.category }}
                </p>
              </div>
            </div>
            <!-- Editable Fields -->
            <div class="space-y-4">
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                  >Prix d'achat</label
                >
                <div class="relative">
                  <input
                    type="number"
                    [(ngModel)]="selectedProduct.purchasePrice"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg font-medium"
                    step="0.01"
                  />
                  <span
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                    >€</span
                  >
                </div>
              </div>
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                  >Prix de vente</label
                >
                <div class="relative">
                  <input
                    type="number"
                    [(ngModel)]="selectedProduct.sellPrice"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg font-medium"
                    step="0.01"
                  />
                  <span
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                    >€</span
                  >
                </div>
              </div>
              <!-- Marge calculée -->
              <div
                class="p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200 dark:border-green-800"
              >
                <div class="flex items-center justify-between">
                  <span class="text-sm text-green-700 dark:text-green-300"
                    >Marge</span
                  >
                  <span
                    class="text-lg font-bold text-green-600 dark:text-green-400"
                  >
                    {{ getMargin(selectedProduct) | number: "1.0-0" }}%
                  </span>
                </div>
                <div class="mt-2 h-2 bg-green-200 rounded-full overflow-hidden">
                  <div
                    class="h-full bg-green-500 rounded-full transition-all"
                    [style.width.%]="getMargin(selectedProduct)"
                  ></div>
                </div>
              </div>
              <div class="grid grid-cols-2 gap-3">
                <div>
                  <label
                    class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                    >Stock</label
                  >
                  <input
                    type="number"
                    [(ngModel)]="selectedProduct.quantity"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-medium"
                  />
                </div>
                <div>
                  <label
                    class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                    >Popularité</label
                  >
                  <select
                    [(ngModel)]="selectedProduct.popularity"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-medium"
                  >
                    <option [ngValue]="2">⭐ Faible (1-4)</option>
                    <option [ngValue]="5">⭐⭐ Moyenne (5-6)</option>
                    <option [ngValue]="7">⭐⭐⭐ Forte (7-8)</option>
                    <option [ngValue]="9">🔥 Très forte (9-10)</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Périssabilité -->
            <div>
              <label
                class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                >Périssabilité</label
              >
              <div class="flex gap-1">
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'high';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-red-400]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.bg-red-50]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.text-red-700]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.border-gray-200]="
                    (selectedProduct.perishability ?? 'high') !== 'high'
                  "
                  [class.text-gray-500]="
                    (selectedProduct.perishability ?? 'high') !== 'high'
                  "
                >
                  🥖 Jour même
                </button>
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'medium';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-amber-400]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.bg-amber-50]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.text-amber-700]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.border-gray-200]="
                    selectedProduct.perishability !== 'medium'
                  "
                  [class.text-gray-500]="
                    selectedProduct.perishability !== 'medium'
                  "
                >
                  ⚠️ 1-2j
                </button>
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'low';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-sky-400]="
                    selectedProduct.perishability === 'low'
                  "
                  [class.bg-sky-50]="selectedProduct.perishability === 'low'"
                  [class.text-sky-700]="selectedProduct.perishability === 'low'"
                  [class.border-gray-200]="
                    selectedProduct.perishability !== 'low'
                  "
                  [class.text-gray-500]="
                    selectedProduct.perishability !== 'low'
                  "
                >
                  🧊 Stock
                </button>
              </div>
            </div>
            <!-- Conservation -->
            <div>
              <label
                class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                >Conservation</label
              >
              <select
                [(ngModel)]="selectedProduct.shelfLife"
                (ngModelChange)="onProductFieldChange()"
                class="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg text-sm font-medium focus:ring-2 focus:ring-blue-500"
              >
                <option value="jour même">📅 Jour même</option>
                <option value="2 jours">📅 2 jours</option>
                <option value="3 jours">📅 3 jours</option>
                <option value="1 semaine">📅 1 semaine</option>
                <option value="1 mois">📅 1 mois</option>
                <option value="6 mois">📅 6 mois</option>
                <option value="1 an">📅 1 an</option>
              </select>
            </div>
            <!-- Actions -->
            <div
              class="pt-4 border-t border-gray-100 dark:border-slate-700 space-y-2"
            >
              <button
                (click)="
                  removeProduct(selectedProduct.id); selectedProduct = null
                "
                class="w-full px-4 py-2.5 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
                Retirer ce produit
              </button>
              <button
                (click)="selectedProduct = null"
                class="w-full px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Confirmer
              </button>
            </div>
          </div>
          <!-- Suggestions IA -->
          <div
            class="p-4 bg-gradient-to-b from-blue-50/50 to-indigo-50/50 border-t border-blue-100"
          >
            <h4
              class="text-sm font-bold text-blue-900 mb-3 flex items-center gap-2"
            >
              <span>💡</span> Suggestions IA
            </h4>
            <div class="space-y-2">
              <!-- Suggestion: marge faible -->
              @if (getMargin(selectedProduct) < 30) {
                <div
                  class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-orange-200 dark:border-orange-800 shadow-sm dark:shadow-slate-900/30"
                >
                  <p class="text-sm text-gray-700 dark:text-gray-300">
                    <span class="text-orange-500">⚠️</span> Marge faible ({{
                      getMargin(selectedProduct) | number: "1.0-0"
                    }}%)
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Prix suggéré:
                    <strong
                      >{{
                        selectedProduct.purchasePrice * 1.5 | number: "1.2-2"
                      }}€</strong
                    >
                    (+50% marge)
                  </p>
                  <button
                    (click)="
                      selectedProduct.sellPrice = +(
                        selectedProduct.purchasePrice * 1.5
                      ).toFixed(2);
                      onProductFieldChange()
                    "
                    class="mt-2 text-xs text-orange-600 font-medium hover:text-orange-800 dark:text-orange-300"
                  >
                    Appliquer →
                  </button>
                </div>
              }
              <!-- Suggestion: marge très élevée -->
              @if (getMargin(selectedProduct) > 100) {
                <div
                  class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-green-200 dark:border-green-800 shadow-sm dark:shadow-slate-900/30"
                >
                  <p class="text-sm text-gray-700 dark:text-gray-300">
                    <span class="text-green-500">✓</span> Excellente marge ({{
                      getMargin(selectedProduct) | number: "1.0-0"
                    }}%)
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Vous pouvez envisager une promo occasionnelle
                  </p>
                </div>
              }
              <!-- Suggestion: stock faible -->
              @if (
                selectedProduct.quantity < 5 && selectedProduct.quantity > 0
              ) {
                <div
                  class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-red-200 dark:border-red-800 shadow-sm dark:shadow-slate-900/30"
                >
                  <p class="text-sm text-gray-700 dark:text-gray-300">
                    <span class="text-red-500">📦</span> Stock bas ({{
                      selectedProduct.quantity
                    }})
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Pensez à réapprovisionner ce produit
                  </p>
                </div>
              }
              <!-- Suggestion: popularité faible -->
              @if (
                selectedProduct.popularity && selectedProduct.popularity < 3
              ) {
                <div
                  class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-blue-200 dark:border-blue-800 shadow-sm dark:shadow-slate-900/30"
                >
                  <p class="text-sm text-gray-700 dark:text-gray-300">
                    <span class="text-blue-500">📊</span> Popularité faible
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Mettez en avant ce produit ou ajustez le prix
                  </p>
                </div>
              }
              <!-- Aucune suggestion -->
              @if (
                getMargin(selectedProduct) >= 30 &&
                getMargin(selectedProduct) <= 100 &&
                selectedProduct.quantity >= 5
              ) {
                <div class="text-center py-2">
                  <p class="text-xs text-gray-400">
                    ✓ Ce produit est bien configuré
                  </p>
                </div>
              }
            </div>
          </div>
        </aside>
      </div>
    }

    <!-- MOBILE: Bottom Sheet Detail Panel (visible on < lg) -->
    @if (selectedProduct) {
      <div class="lg:hidden fixed inset-0 z-40">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/40 backdrop-blur-sm"
          (click)="selectedProduct = null"
        ></div>
        <!-- Bottom Sheet -->
        <div
          class="absolute bottom-0 left-0 right-0 bg-white dark:bg-slate-800 rounded-t-2xl shadow-2xl max-h-[85vh] overflow-y-auto animate-slide-up"
        >
          <!-- Handle -->
          <div
            class="sticky top-0 bg-white dark:bg-slate-800 pt-3 pb-2 px-4 border-b border-gray-100 dark:border-slate-700 z-10"
          >
            <div class="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-3"></div>
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <span class="text-3xl">{{ selectedProduct.productIcon }}</span>
                <div>
                  <h3 class="font-bold text-gray-900 dark:text-white">
                    {{ selectedProduct.name }}
                  </h3>
                  <p class="text-xs text-gray-500 dark:text-gray-400">
                    {{ selectedProduct.category }}
                  </p>
                </div>
              </div>
              <button
                (click)="selectedProduct = null"
                class="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-lg"
              >
                <svg
                  class="w-5 h-5 text-gray-500 dark:text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <!-- Content -->
          <div class="p-4 space-y-4">
            <!-- Quick Price Edit -->
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1"
                  >Prix d'achat</label
                >
                <div class="relative">
                  <input
                    type="number"
                    [(ngModel)]="selectedProduct.purchasePrice"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg text-lg font-medium"
                    step="0.01"
                  />
                  <span
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
                    >€</span
                  >
                </div>
              </div>
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1"
                  >Prix de vente</label
                >
                <div class="relative">
                  <input
                    type="number"
                    [(ngModel)]="selectedProduct.sellPrice"
                    (ngModelChange)="onProductFieldChange()"
                    class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg text-lg font-medium"
                    step="0.01"
                  />
                  <span
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
                    >€</span
                  >
                </div>
              </div>
            </div>
            <!-- Marge -->
            <div
              class="p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200 dark:border-green-800"
            >
              <div class="flex items-center justify-between">
                <span class="text-sm text-green-700 dark:text-green-300"
                  >Marge</span
                >
                <span
                  class="text-lg font-bold text-green-600 dark:text-green-400"
                  >{{ getMargin(selectedProduct) | number: "1.0-0" }}%</span
                >
              </div>
              <div class="mt-2 h-2 bg-green-200 rounded-full overflow-hidden">
                <div
                  class="h-full bg-green-500 rounded-full"
                  [style.width.%]="getMargin(selectedProduct)"
                ></div>
              </div>
            </div>
            <!-- Stock & Popularité -->
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1"
                  >Stock</label
                >
                <input
                  type="number"
                  [(ngModel)]="selectedProduct.quantity"
                  (ngModelChange)="onProductFieldChange()"
                  class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg font-medium"
                />
              </div>
              <div>
                <label
                  class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1"
                  >Popularité</label
                >
                <select
                  [(ngModel)]="selectedProduct.popularity"
                  (ngModelChange)="onProductFieldChange()"
                  class="w-full px-3 py-2.5 border border-gray-200 dark:border-slate-700 rounded-lg font-medium"
                >
                  <option [ngValue]="2">⭐ Faible (1-4)</option>
                  <option [ngValue]="5">⭐⭐ Moyenne (5-6)</option>
                  <option [ngValue]="7">⭐⭐⭐ Forte (7-8)</option>
                  <option [ngValue]="9">🔥 Très forte (9-10)</option>
                </select>
              </div>
            </div>
            <!-- Périssabilité -->
            <div>
              <label
                class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                >Périssabilité</label
              >
              <div class="flex gap-1">
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'high';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-red-400]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.bg-red-50]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.text-red-700]="
                    (selectedProduct.perishability ?? 'high') === 'high'
                  "
                  [class.border-gray-200]="
                    (selectedProduct.perishability ?? 'high') !== 'high'
                  "
                  [class.text-gray-500]="
                    (selectedProduct.perishability ?? 'high') !== 'high'
                  "
                >
                  🥖 Jour même
                </button>
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'medium';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-amber-400]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.bg-amber-50]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.text-amber-700]="
                    selectedProduct.perishability === 'medium'
                  "
                  [class.border-gray-200]="
                    selectedProduct.perishability !== 'medium'
                  "
                  [class.text-gray-500]="
                    selectedProduct.perishability !== 'medium'
                  "
                >
                  ⚠️ 1-2j
                </button>
                <button
                  type="button"
                  (click)="
                    selectedProduct.perishability = 'low';
                    onProductFieldChange()
                  "
                  class="flex-1 py-2 px-1 rounded-lg border-2 text-xs font-medium transition-all"
                  [class.border-sky-400]="
                    selectedProduct.perishability === 'low'
                  "
                  [class.bg-sky-50]="selectedProduct.perishability === 'low'"
                  [class.text-sky-700]="selectedProduct.perishability === 'low'"
                  [class.border-gray-200]="
                    selectedProduct.perishability !== 'low'
                  "
                  [class.text-gray-500]="
                    selectedProduct.perishability !== 'low'
                  "
                >
                  🧊 Stock
                </button>
              </div>
            </div>
            <!-- Conservation -->
            <div>
              <label
                class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1"
                >Conservation</label
              >
              <select
                [(ngModel)]="selectedProduct.shelfLife"
                (ngModelChange)="onProductFieldChange()"
                class="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg text-sm font-medium"
              >
                <option value="jour même">📅 Jour même</option>
                <option value="2 jours">📅 2 jours</option>
                <option value="3 jours">📅 3 jours</option>
                <option value="1 semaine">📅 1 semaine</option>
                <option value="1 mois">📅 1 mois</option>
                <option value="6 mois">📅 6 mois</option>
                <option value="1 an">📅 1 an</option>
              </select>
            </div>
            <!-- Actions -->
            <div
              class="pt-3 border-t border-gray-100 dark:border-slate-700 flex gap-2"
            >
              <button
                (click)="
                  removeProduct(selectedProduct.id); selectedProduct = null
                "
                class="flex-1 px-4 py-3 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg text-sm font-medium flex items-center justify-center gap-2"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
                Retirer
              </button>
              <button
                (click)="selectedProduct = null"
                class="flex-1 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium flex items-center justify-center gap-2"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </main>
</div>

<!-- Modal de confirmation pour quitter sans sauvegarder -->
<app-confirm-leave-modal
  [show]="showLeaveConfirmation"
  (confirm)="onConfirmLeave()"
  (cancel)="onCancelLeave()"
>
</app-confirm-leave-modal>
